/**
 * SustainabilityVisual.js
 * 
 * Displays the visual for the Sustainability section.
 * Extracted from legacy MainRight.js logic using IlAdd active="su".
 * Ensures correct markup and class names for CSS compatibility.
 */

export const SustainabilityVisual = ({ lower }) => {
  if (lower === "left") {
    return (<div className="il-add" lower="left" style={{ backgroundImage: `url("/img/sustainability/su-two.jpeg")`}}></div>);
  } else if (lower === "right") {
    return (<div className="il-add" lower="right" style={{ backgroundImage: `url("/img/sustainability/su-three.jpeg")`}}></div>);		
  } else {
    // Default or "upper" case
    return (<div className="il-add" style={{ backgroundImage: `url("/img/sustainability/su-upperB.jpeg")`}}></div>);
  }
};
